import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bulk-fill"
export default class extends Controller {
  static targets = ["daysInput", "dayField", "profitField", "onlyEmptyCheckbox", "monthField"]
  static values = { profitFillUrl: String }

  fillAll() {
    const daysValue = this.daysInputTarget.value
    const onlyEmpty = this.hasOnlyEmptyCheckboxTarget && this.onlyEmptyCheckboxTarget.checked

    if (daysValue === "" || daysValue < 0) {
      alert("Пожалуйста, введите корректное количество смен")
      return
    }

    this.dayFieldTargets.forEach(field => {
      if (onlyEmpty) {
        if (this.isBlank(field)) {
          field.value = daysValue
        }
      } else {
        field.value = daysValue
      }
    })
  }

  async fillProfitPlans(event) {
    if (!this.hasProfitFillUrlValue || !this.hasMonthFieldTarget) {
      alert("Не удалось определить параметры для автозаполнения")
      return
    }

    const emptyFields = this.profitFieldTargets.filter(field => this.isBlank(field))
    if (emptyFields.length === 0) {
      return
    }

    const button = event.currentTarget
    const originalHtml = button.innerHTML

    button.disabled = true
    button.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Заполняется...'

    try {
      const response = await fetch(this.profitFillUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": this.csrfToken
        },
        body: JSON.stringify({
          month_for: this.monthFieldTarget.value,
          user_ids: emptyFields.map(field => field.dataset.userId).filter(Boolean)
        })
      })

      const data = await response.json()
      if (!response.ok) {
        throw new Error(data.error || "Не удалось получить значения шкалы планов")
      }

      emptyFields.forEach(field => {
        const value = data.profit_plans?.[field.dataset.userId]
        if (this.isBlank(field) && value !== undefined && value !== null && value !== "") {
          field.value = value
        }
      })
    } catch (error) {
      alert(error.message || "Произошла ошибка при автозаполнении")
    } finally {
      button.disabled = false
      button.innerHTML = originalHtml
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
  }

  isBlank(field) {
    return field.value === "" || field.value === null
  }
}
